import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Chart } from "highcharts-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileIncomeChart',
  props: {
    data: { type: Array<number>, default: [] }
},
  emits: {
    'yearSelected': null
},
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const chartOptions = {
    chart: {
        type: 'column',
        spacingLeft: 0,
        marginRight: 0,
        animation: {
            duration: 1100
        }
    },
    title: {
        text: undefined
    },
    xAxis: {
        title: {
            text: 'Retirement Year'
        },
        crosshair: true,
        accessibility: {
            description: 'Retirement Year'
        }
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        },
    },
    tooltip: {
        enabled: false
    },
    plotOptions: {
        column: {
            pointPadding: 0.2,
            borderWidth: 0,
        },
        series: {
            cursor: 'pointer',
            events: {
                click: function(event) {
                    emit('yearSelected', event.point.category - 1);
                }
            },
            color: 'rgb(40, 121, 188)'
        }
    },
    series: [
        {
            name: '',
            pointStart: 1,
            data: props.data,
            showInLegend: false,
            selected: 4
        }
    ]
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chart), { options: chartOptions }))
}
}

})